'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002e$002dList$002dElement$0024package$0024$002dPerson2$00241 from "./samples.-List-Element$package$-Person2$1.js";
var $p;
/** @constructor */
function $c_Lsamples_ListElement$package$Person2$3$() {
}
export { $c_Lsamples_ListElement$package$Person2$3$ as $c_Lsamples_ListElement$package$Person2$3$ };
$p = $c_Lsamples_ListElement$package$Person2$3$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_ListElement$package$Person2$3$;
/** @constructor */
function $h_Lsamples_ListElement$package$Person2$3$() {
}
export { $h_Lsamples_ListElement$package$Person2$3$ as $h_Lsamples_ListElement$package$Person2$3$ };
$h_Lsamples_ListElement$package$Person2$3$.prototype = $p;
$p.b = (function() {
  return "Person2";
});
$p.Uw = (function(x$0) {
  return new $j_samples$002e$002dList$002dElement$0024package$0024$002dPerson2$00241.$c_Lsamples_ListElement$package$Person2$1((x$0.g(0) | 0), x$0.g(1), (x$0.g(2) | 0));
});
$p.y = (function(p) {
  return this.Uw(p);
});
var $d_Lsamples_ListElement$package$Person2$3$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_ListElement$package$Person2$3$, "samples.ListElement$package$Person2$3$", ({
  po: 1,
  e: 1,
  g: 1
}));
export { $d_Lsamples_ListElement$package$Person2$3$ as $d_Lsamples_ListElement$package$Person2$3$ };
